import React from "react";

import { getHours, getISODay } from "date-fns";
import { toZonedTime } from "date-fns-tz";

import { MediaLightboxRef } from "../lightbox/mediaLightbox";

const chatScript = () => {
  try {
    const chatSettings = JSON.parse(process.env.GATSBY_CHAT_SF_ENV);

    window.embeddedservice_bootstrap.settings.language = "en_US"; // For example, enter 'en' or 'en-US'

    window.addEventListener("onEmbeddedMessagingReady", () => {
      window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(
        { Chat_Start_Webpage: window.location.pathname },
      );
    });

    window.embeddedservice_bootstrap.init(
      chatSettings.id,
      chatSettings.name,
      chatSettings.link,
      {
        scrt2URL: chatSettings.scrt2URL,
      },
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("Error loading Embedded Messaging: ", err);
  }
};

const businessHours: {
  [key: string]: {
    end: number;
    start: number;
    timeZone: string;
    workingWeekBegin: number;
    workingWeekEnd: number;
  };
} = {
  gb: {
    end: 17,
    start: 9,
    timeZone: "Europe/London",
    workingWeekBegin: 1,
    workingWeekEnd: 5,
  },
};

const isBusinessHours = () => {
  const config = businessHours[process.env.GATSBY_SITE];

  if (!config) {
    return true;
  }

  const now = new Date();
  const zoned = toZonedTime(now, config.timeZone);

  const weekday = getISODay(zoned);
  const hour = getHours(zoned);

  return (
    weekday >= config.workingWeekBegin
    && weekday <= config.workingWeekEnd
    && hour >= config.start
    && hour < config.end
  );
};

const onExternalContentEnabledChange = (mediaModal: React.RefObject<MediaLightboxRef>, externalContentEnabled = false) => {
  const chatSettings = JSON.parse(process.env.GATSBY_CHAT_SF_ENV);
  const script = document.createElement("script");

  switch (process.env.GATSBY_SITE) {
    case "gb":
      script.id = "sfMessage";
      script.type = "text/javascript";
      script.src = `${chatSettings.link}/assets/js/bootstrap.min.js`;
      script.async = true;
      script.onload = () => {
        window.initEmbeddedMessaging();
      };

      if (externalContentEnabled) {
        mediaModal?.current?.close();

        if (!document.getElementById(script.id)) {
          window.initEmbeddedMessaging = chatScript;
          document.body.appendChild(script);
        }
      } else {
        document.getElementById(script.id)?.remove();
        document.getElementById("embedded-messaging")?.remove();
        document.getElementById("embeddedMessagingSiteContextFrame")?.remove();
        document.getElementById("inert-script")?.remove();
        document.getElementById("embeddedMessagingBootstrapStyles")?.remove();
        window.initEmbeddedMessaging = undefined;
        window.embeddedservice_bootstrap = undefined;
      }
      break;
    case "cl":
      script.id = "sfMessage";
      script.type = "text/javascript";
      script.src = `${chatSettings.link}`;
      script.async = true;
      script.defer = true;

      if (externalContentEnabled) {
        mediaModal?.current?.close();

        if (!document.getElementById(script.id)) {
          document.body.appendChild(script);
        }
      } else {
        document.getElementById(script.id)?.remove();
        document.getElementById("plotdesk-chat-icon")?.remove();
        document.getElementById("plotdesk-chat-widget")?.remove();
      }
      break;
    default:
      break;
  }
};

export {
  isBusinessHours,
  onExternalContentEnabledChange,
};
